import { Observable } from 'rxjs';

/** entityType codes used by UserEntityMapping. */
export const USER_ENTITY_TYPES = { Hub: 201, Spoke: 202 };

export interface UserEntityMapping {
  id?: any;
  userEntityMappingId?: any;
  userId: any;
  userRoleType: any;
  entityType: number;
  entityId: any;
  restrictFlag: boolean;
  isActive: boolean;
  createdBy?: number;
}

export abstract class UserEntityMappingData {
  abstract list(url: string): Observable<any>;
  abstract getById(url: string): Observable<UserEntityMapping>;
  abstract create(url: string, data: UserEntityMapping): Observable<any>;
  abstract update(url: string, data: UserEntityMapping): Observable<any>;
}
